import { useLanguage } from "../context/LanguageContext";

export const getYearPlaceHolder = (year, language) => {
    const yearsPlaceHolders = {
        1: "A1 - Level 1",
        2: "A1 - Level 2",
        3: "A1 - Level 3",

        4: "A2 - Level 1",
        5: "A2 - Level 2",
        6: "A2 - Level 3",

        7: "B1 - Level 1",
        8: "B1 - Level 2",
        9: "B1 - Level 3",

        10: "B2 - Level 1",
        11: "B2 - Level 2",
    };
    return yearsPlaceHolders[year];
};

export const years = [
    { value: "1", text: getYearPlaceHolder(1) },
    { value: "2", text: getYearPlaceHolder(2) },
    { value: "3", text: getYearPlaceHolder(3) },
    { value: "4", text: getYearPlaceHolder(4) },
    { value: "5", text: getYearPlaceHolder(5) },
    { value: "6", text: getYearPlaceHolder(6) },
    { value: "7", text: getYearPlaceHolder(7) },
    { value: "8", text: getYearPlaceHolder(8) },
    { value: "9", text: getYearPlaceHolder(9) },
    { value: "10", text: getYearPlaceHolder(10) },
    { value: "11", text: getYearPlaceHolder(11) },
];
